import React from "react";
import classnames from "classnames";
import { FlightInformation, RountTrip } from "../../../components";
import { renderRecordValue } from "../../../utils";
import { STATUSES_STYLING } from "../../../constants/styles/statuses";
import {
  getRiderActualHeightForBariaticVehicleType,
  getRiderActualWeightForBariaticVehicleType,
  getRideStatusLabel,
  getUberDriverWaitMinutesFromRecord,
} from "../../../utils/helpers";

import styles from "./index.module.css";
import { vehicleOptionsDictionary } from "../../../dictionaries";
import { Popover, Tag } from "antd";
import { OverNight } from "../../../components/common/OverNight/OverNight";
import { mhAdminRescheduleMessage, RIDE_STATUSES, UBER_TEXT } from "../../../constants/constants";
import { RescheduleRideIcon } from "../../../components/common/RescheduleRideIcon/RescheduleRideIcon";
import classNames from "classnames";
import { PatientSpecialAccommodationsIcon } from "../../../components/common/SpecialAccommodationIcon/SpecialAccommodationIcon";
import { FrequentFlyerPatientIcon } from "../../../components/common/FrequentFlyerPatientIcon/FrequentFlyerIcon";
import { AdditionalSeat } from "../../../components/common/AdditionalSeat/AdditionalSeat";
import { UberHealthTag } from "../../../components/common/UberHealthTag/UberHealthTag";

export const renderColumns = () => {
  return [
    {
      title: "Organization",
      dataIndex: "healthOrganizationName",
      key: "healthOrganizationName",
      width: 180,
      render: (text) => (
        <div
          className={classnames({
            [styles.organizationCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(text?.split("_").join(" "))}
        </div>
      ),
    },

    {
      title: "Transport Co.",
      dataIndex: "transportCompanyName",
      key: "transportCompanyName",
      width: 180,
      render: (text) => (
        <div
          className={classnames({
            [styles.organizationCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(text?.split("_").join(" "))}
        </div>
      ),
    },
    {
      title: "Ride ID",
      dataIndex: "seqId",
      key: "seqId",
      width: 155,
      render: (text, record) => (
        <div className={classnames({ [styles.cellValue]: true })}>
          {record?.flightInfo ? (
            <Popover
              content={<FlightInformation flightInfo={record?.flightInfo} />}
              placement="topLeft"
              getPopupContainer={() => document.querySelector(".ant-table")}
            >
              <span style={{ color: "blue", textDecorationLine: "underline" }}>
                {renderRecordValue(text)}
              </span>
            </Popover>
          ) : (
            renderRecordValue(text)
          )}

          {record?.isReRequested && (
            <div className={styles.uberNoShowCell}>
              <Tag className={styles.uberReRequestedTag}>
                Re-Requested
              </Tag>
            </div>
          )}

          <br />
          <div className={styles.displayIcons}>
            <OverNight record={record} />
            <AdditionalSeat record={record} />
          </div>
          <div className={styles.dflex}>
            <RountTrip record={record} />
            {(record?.status === RIDE_STATUSES.RESCHEDULED || record?.rescheduledFrom) && (
              <RescheduleRideIcon />
            )}
          </div>
        </div>
      ),
    },

    {
      title: "Rider Name",
      dataIndex: "rider",
      key: "rider",
      width: 150,
      render: (text, record) => (
        <div
          className={classnames({
            [styles.riderCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span style={{ width: "100px" }}>{renderRecordValue(text)}</span>
            <span style={{ display: "flex", alignItems: "center", marginRight: "8px" }}>
              {record.riderInfo?.specialAccommodations && <PatientSpecialAccommodationsIcon specialNeeds={record?.riderInfo?.specialAccommodationsNeeds || null} />}
              {record.riderInfo?.frequentFlyer && <FrequentFlyerPatientIcon fill="#E1F4D3" />}
            </span>
          </span>
        </div>
      ),
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicleType",
      key: "vehicleType",
      width: 250,
      render: (text, record) => (
        <>
          <div
            className={classnames({
              [styles.vehicleCellValue]: true,
              [styles.cellValue]: true,
            })}
          >
            {renderRecordValue(vehicleOptionsDictionary[text])}
            {text === 'uberAmbulatoryRide' && <UberHealthTag />}
          </div>
          <div
            className={classnames({
              [styles.vehicleCellValue]: true,
              [styles.cellValue]: true,
              [styles.actualWeight]: true,
            })}
          >
            <div> {getRiderActualWeightForBariaticVehicleType(text, record)}</div>
            <div> {getRiderActualHeightForBariaticVehicleType(text, record)}</div>
          </div>
        </>
      ),
    },

    {
      title: "Pickup Date",
      dataIndex: "pickUpDate",
      key: "pickUpDate",
      width: 200,
      render: (value) => (
        <div
          className={classnames({
            [styles.pickUpDateCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(value)}
        </div>
      ),
    },
    {
      title: "Ride Status",
      dataIndex: "readableStatus",
      key: "readableStatus",
      width: 220,
      render: (text, record) => {
        const isUnableToFulfill = record?.status === RIDE_STATUSES.UNABLE_TO_FULFILL;
        const isExpiredUberRide =
          record?.status === RIDE_STATUSES.EXPIRED &&
          record?.vehicleType === "uberAmbulatoryRide";
        const driverWaitMins = getUberDriverWaitMinutesFromRecord(record);
        return (
          <div
            className={classnames({
              [styles.statusCellValue]: true,
              [styles.cellValue]: true,
              // Do not apply status color class for "Unable to fulfill"
              [STATUSES_STYLING[text]]: !isUnableToFulfill,
            })}
          >
            {text.toLowerCase() === RIDE_STATUSES.RESCHEDULED.toLowerCase() ||
            record?.rescheduledFrom ? (
              <Popover
                content={
                  text.toLowerCase() === RIDE_STATUSES.RESCHEDULED.toLowerCase()
                    ? mhAdminRescheduleMessage
                    : `Rescheduled Ride`
                }
                overlayClassName={classNames({
                  [styles.overlay]: true,
                })}
                getPopupContainer={() => document.body}
              >
                <div>
                  {renderRecordValue(getRideStatusLabel(text, RIDE_STATUSES.CANCELED))}
                </div>
              </Popover>
            ) : (
              <>
                {renderRecordValue(getRideStatusLabel(text, RIDE_STATUSES.CANCELED))}
                {isUnableToFulfill && (
                  <div className={styles.uberNoShowText}>
                    No-show
                    {typeof driverWaitMins === "number" && driverWaitMins > 0 && (
                      <>
                        {" "}
                        | Driver wait {driverWaitMins} min
                        {driverWaitMins > 1 ? "s" : ""}
                      </>
                    )}
                  </div>
                )}
                {isExpiredUberRide && (
                  <div className={styles.uberNoShowText}>
                    {UBER_TEXT.NO_DRIVERS_AVAILABLE}
                  </div>
                )}
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Recurring",
      dataIndex: "recurringRideIndex",
      key: "recurringRideIndex",
      width: 120,
      render: (text, record) => {
        return (
          <div
            className={classnames({
              [styles.recurringInfo]: true,
              [styles.recurringCellValue]: true,
              [styles.lastRide]: record.isLastRecurring,
            })}
          >
            {renderRecordValue(record.recurringRideIndex)}
          </div>
        );
      },
    },
  ];
};
